define('TagCommander',['jquery','backbone','underscore','site_vars','js-cookie','sha256'],function($,Backbone,_,site_vars,Cookies,sha256){

    var app,
        BASE_URL = site_vars.base_url,
        BASE_TC_VARS_JS = BASE_URL + 'FRONTOFFICE/ajax/tc_vars.js.php?',
        ignoreInitialPageLoad = true,
        COUNTRY_CODE = site_vars.country_code,
        CURRENCY_CODE = site_vars.currency_code;


    //function LoadScriptSync(url){
    //    $.ajax({
    //        async: false,
    //        url: url,
    //        dataType: "script"
    //    });
    //}
    // function LoadScriptAsync(url){
    //     return $.ajax({
    //         url: url,
    //         dataType: "script"
    //     });
    // }

    var _ga, client_id = '';
    function getClientId(){
        // représente un identifiant unique, pour l'utilisateur connecté uniquement,
        // basé sur le cookie Google Analytics et l'id_customer
        if(!_ga) _ga = Cookies.get('_ga');
        if(_ga && client_id === ''){
            var id_customer, customer = app.getCustomer();
            id_customer = customer.get('id_customer');
            if(id_customer){
                client_id = sha256(_ga+id_customer);
            }
        }
        return client_id;
    }
    function resetClientId(){
        client_id = '';
        getClientId();
    }

    function formatDetect(){
        var format_detect,
            is_mobile_format = app.isMobile(),
            is_desktop_format = app.isDesktop();

        format_detect = is_mobile_format ? 'm' :
            is_desktop_format               ? 'd': 't';
        return format_detect;
    }

    function getEnvTemplate (pagename) {
        var env_template_cp = {
                home :"homepage" ,
                category:"category_main" ,
                allcategories:"category_main" ,
                product:"product" ,
                cart:"funnel_basket" ,
                //cart_set_infos:"funnel_step2" , // mobile
                //cart_delivery_informations:"funnel_step2" ,
                checkoutopc:'funnel_step3' ,
                //checkout_payment:'funnel_step3' ,
                checkoutconfirmation:"funnel_confirmation" ,
                authentification:"myaccount_form" ,
                account:"myaccount_other" ,
                //"404":"other_errors" ,
                notfound:"error_page_not_found" ,
            };

        var env_template = env_template_cp[pagename] || 'other_generic';
        return env_template;
    }

    function getPageCat1 (pagename,options) {
        var page_cat_1 = pagename;
        switch(pagename){
            case 'cross_selling':
                page_cat_1 = options.label || '';
                break;
            case 'checkoutopc':
                page_cat_1 =  'Checkout';
                break;
             case 'checkoutconfirmation':
                page_cat_1 = 'Checkout confirmation';
                break;
            case 'category':
                var category = app.getCategories().findWhere({link_rewrite:options.link_rewrite});
                if(category){
                    page_cat_1 = category.getName();
                }
                break;
            case 'product':
                var product = app.getProduct(options.id_product), category;
                if(product && (category = product.getCategoryDefault())){
                    page_cat_1 = category.getName();
                }
                break;
            case 'store':
                var store;
                if(options.subpage==='single' && (store = app.getStore(options.id_store))){
                    page_cat_1 = store.getCity() || '';
                }else{
                    page_cat_1 = options.search || '';
                }
                break;
            case 'widget':
                page_cat_1 = options.groupName || '';
                break;
        }
        return page_cat_1;
    }

    function getPageCat2(pagename,options){
        var page_cat_2 = '';
        switch(pagename){
            case 'checkoutopc':
                switch (options.order_step) {
                    case 1:
                        page_cat_2 = 'Cart';break;
                    case 2:
                        page_cat_2 = 'CrossSelling';break;
                    case 3:
                        page_cat_2 = 'Payment';break;
                    default:
                        page_cat_2 = 'Step '+options.order_step;break;
                }
            case 'product':
                // TODO product name
                var product = app.getProduct(options.id_product);
                if(product){
                    page_cat_2 = product.getName() || '';
                }
                break;
            case 'store' :
                var store;
                if(options.subpage==='single' && (store = app.getStore(options.id_store))){
                    page_cat_2 = store.getName() || '';
                }
                break;
            case 'account':
                page_cat_2 = options.account_page;
                break;
            case 'news':
                page_cat_2 = options.flag_link_rewrite || '';
                break;
            case 'supportcenter':
                var supportCenter = options.supportCenter, category;
                if(supportCenter && (category = supportCenter.getCurrentCategory())){
                    page_cat_2 = category.get('name');
                }
                break;

        }
        return page_cat_2;
    }

    function getPageCat3(pagename,options){
        var page_cat_3 = '';
        switch(pagename){
            case 'supportcenter':
                var supportCenter = options.supportCenter, article;
                if(supportCenter && (article = supportCenter.getCurrentArticle())){
                    page_cat_3 = article.get('name');
                }
                break;
            case 'news':
                page_cat_3 = options.news_link_rewrite || '';
                break;


        }
        return page_cat_3;
    }

    function getPageCatId1(pagename,options){
        var page_cat_id_1 = '';
        switch(pagename){
            case 'category':
                page_cat_id_1 = options.id_category || '';
                break;
        }
        return page_cat_id_1;
    }

    function getOrderStep(pagename,options){
        switch(pagename){
            case 'cart':
                return '1';
            case 'cross_selling':
            case 'checkoutopc':
                return options.order_step || '';
            default:
                return '';
        }
    }

    function getPageName(pagename,options){
        var name = pagename;
        switch(pagename){
            case 'CheckoutOpc':
                name = 'Checkout';
                break;
            case 'Widget':
                name = 'Landing Page';
                break;
            case 'Store':
                if(options.subpage !== 'list'){
                    name = 'Store page';
                }else{
                    name = 'Store locator';
                }
                break;
            case 'News':
                if(!options.news_link_rewrite){
                    name = 'All news';
                }
                break;
            case 'CheckoutConfirmation':
                name = 'Checkout confirmation';
                break;
            default:
        }
        // capitalized
        name = name.charAt(0).toUpperCase() + name.slice(1)
        return name;
    }

    function getListProduct(type,options){
        type = type ? type : 'default';
        var cart = app.getCart(),
            order,
            list_product = [],
            cartProductCollection = cart.getProducts();
        if (type === 'consumables') {
            cartProductCollection = cart.getConsumables();
        }
        if( type === 'order'){
            return window.tc_vars.order_products || [];
        }
        list_product = cartProductCollection.map(function(cartProduct,index){
            try {
                var product = cartProduct.getProduct(),
                    quantity = cartProduct.getQuantity(),
                    category = product.getCategoryDefault(), product_vars,
                    product_id = product.id,
                    product_name = product.getName(),
                    product_cat = category ? category.getName():'',
                    product_cat_id = category ? category.id:'',
                    product_unitprice_ati = product.getPrice('ttc',true,cart),
                    product_unitprice_tf = product.getPrice('ht',true,cart),
                    product_isbundle = product.isMenu()?'Yes':'No',
                    product_ref = product.get('reference') || '';
                if(type === 'consumables'){
                     product_vars = {
                        order_annexe_id:product_id,
                        order_annexe_ref:product_ref,
                        order_annexe_cat:product_cat,
                        order_annexe_name:product_name,
                        order_annexe_quantity:quantity
                    }
                }else{
                    product_vars = {
                        order_product_cat:product_cat,
                        order_product_cat_id:product_cat_id,
                        order_product_currency:CURRENCY_CODE,
                        order_product_discount_ati:0,
                        order_product_discount_tf:0,
                        order_product_id:product_id,
                        order_product_ref:product_ref,
                        order_product_isbundle:product_isbundle,
                        order_product_name:product_name,
                        order_product_quantity:quantity,
                        order_product_unitprice_ati:product_unitprice_ati,
                        order_product_unitprice_tf:product_unitprice_tf,
                        order_product_index:index,
                    }
                }
                return product_vars;
            }catch(err){
                return {
                    order_product_id: cartProduct.id,
                }
            }
        });
        return list_product;
    }

    function getTagCommanderProductVars(pagename,options){

        var id_product = options.id_product || '',
            product = app.getProduct(id_product),
            product_ref = '' ,
            product_name = '' ,
            product_cat = '' ,
            product_cat_id = '' ,
            product_price_ttc = '' ,
            product_price_ht = '',
            product_currency = '',
            product_url_page = '',
            product_isbundle = '',
            list_products_cat = ''
        ;

        if(pagename === 'product' && product){
            var categoryDefault = product.getCategoryDefault();
            product_ref = product.get('reference');
            product_name = product.get('name');
            product_price_ttc = product.getPrice('ttc',true);
            product_price_ht = product.getPrice('ht',true);
            product_currency = CURRENCY_CODE,
            product_cat = categoryDefault ? categoryDefault.getName() : '';
            product_cat_id = categoryDefault ? categoryDefault.id : '';
            product_url_page = product.getUrl();
            product_isbundle = product.isMenu() ? 'Yes' : 'No';
        }

        if(pagename === 'category' && options.list_products_cat){
            list_products_cat = _(options.list_products_cat).map(function(id){return parseInt(id)});
        }

        var tc_vars_product = {
            //-----------------------------------------------------------------
            // product
            //-----------------------------------------------------------------
            product_id : id_product ,
            // Product ID
            product_ref : product_ref,
            // Product REF
            product_name : product_name ,
            // Product name
            product_cat : product_cat ,
            // Product name
            product_cat_id : product_cat_id ,
            // Product category
            product_unitprice_ati : product_price_ttc ,
            // Product unit price ATI (all tax included)
            product_discount_ati : 0 ,
            // Product discount price ATI (all tax included)
            product_unitprice_tf : product_price_ht ,
            // Product unit price TF (tax free)
            product_discount_tf : 0 ,
            // Product discount price TF (tax free)
            product_currency : product_currency ,
            // Currency code (ISO code 4217)
            product_url_page : product_url_page ,
            // Product URL (URL of the product page)
            //  product_url_picture : product_url_picture,
            // Main picture absolute path from the first slash (URL of the product main image)
            product_isbundle : product_isbundle ,
            // Product bundle or not
            list_products_cat : list_products_cat ,
        };
        return tc_vars_product;
    }


    function getFilter(){
        var filter = '',
            tags = app.getTags(), allTags = tags.isAllChecked(),
            allergens = app.getAllergenGroups(), allAllergens = allergens.isAllChecked();
        if(allTags && allAllergens){
            filter = 'No';
        }else{
            if(!allAllergens){
                filter = allergens.getChecked().pluck('name').join('/');
            }
            if(!allTags){
                filter += (allAllergens?'':'//')+tags.getChecked().pluck('name').join('/');
            }
        }
        return filter;
    }

    function getTagCommanderOrderVars(pagename,options){
        var customer = app.getCustomer(),
            cart = app.getCart(),
            order = options.order || customer.getLastOrder(),
            store = cart.getStore() || (order ? order.getStore() : undefined),
            order_id = '',
            id_cart = cart.get('id'),
            //
            order_products,
            delai = '',
            //
            order_amount_ati_without_sf  = '',
            order_amount_ati_with_sf  = '',
            order_discount_ati  = '',
            order_ship_ati  = '',
            order_amount_tf_without_sf  = '',
            order_amount_tf_with_sf  = '',
            order_discount_tf  = '',
            order_ship_tf  = '',
            order_tax  = '',
            order_comin_amount = '',
            order_payment_methods  = '',
            order_shipping_method  = '',
            order_shipping_date  = '',
            order_shipping_time  = '',
            order_status  = '',
            order_promo_code  = '',
            order_currency  = '',
            order_newcustomer  = '',
            order_piece_number  = '',
            order_products_number  = 0,
            order_product_list_name  = pagename,
            order_products  = [],
            order_products_annexe  = [],
            total_burn = 0,
            //-----------------------------------------------------------------
            // store
            //-----------------------------------------------------------------
            store_id = '',
            store_name = '',
            store_postal_code = '',
            store_city = '',
            store_country = '',
            //
            user_recency = order ? order.get('date_add') : '',
            filter = '';

        if(pagename === 'Store' && options.subpage==='single'){
            // si on est sur une fiche boutique, on utilise les données de la boutique
            var stores = app.getStores();
            if(options.link_rewrite){
                store = stores.findWhere({link_rewrite:options.link_rewrite});
            }else{
                store = stores.get(options.id_store);
            }
        }

        if(store){
            store_id = store.id;
            store_name = store.getName();
            store_postal_code = store.formatPostcode();
            store_city = store.getCity();
            store_country = COUNTRY_CODE;
        }

        if(pagename === 'CheckoutConfirmation'){
            // Checkout confirmation
            if(!!order) {
                order_id = order.id;
                order_amount_ati_without_sf = order.getTotalPaid(true, true),
                    order_amount_ati_with_sf = order.getTotalPaid(true, false),
                    order_discount_ati = '',
                    order_ship_ati = order.getExtraPriceValue(),
                    order_amount_tf_without_sf = '',
                    order_amount_tf_with_sf = '',
                    order_discount_tf = '',
                    order_ship_tf = '',
                    order_tax = '',
                    order_comin_amount = order.getAmountReduce(),
                    order_payment_methods = order.getPaymentMethodName(),
                    order_shipping_method = '',
                    order_shipping_date = '',
                    order_shipping_time = '',
                    order_status = order.getStatusName(),
                    order_promo_code = '',
                    order_currency = CURRENCY_CODE,
                    order_newcustomer = '',
                    order_piece_number = '',
                    order_products = getListProduct('order', {order: order}),
                    total_burn = order.getAmountReduce(),
                    order_products_annexe = []; // todo
            }
        }else{
            // Cart & default
            // TODO
            var cartPriceTTC = cart.getPriceTTC(),
                cartPriceHT = cart.getValueOf('total_price_ht'),
                cartPriceTTCWithoutExtraPrice = cart.getPriceTTC({ignoreExtraPrices:true}),
                totalDiscountTTC = cart.getValueOf('total_discount'),
                extraPriceHT = cart.getExtraPriceValue('price_ht')
                //paymentMethod = cart.getPaymentMethod()
                ;


            delai = cart.formatDeliveryDelay();
            order_id = '';
            order_amount_ati_without_sf = cartPriceTTCWithoutExtraPrice,
            order_amount_ati_with_sf  = cartPriceTTC,
            order_discount_ati  = totalDiscountTTC,
            order_ship_ati  = cart.getExtraPriceValue(),
            order_amount_tf_without_sf  = cartPriceHT-extraPriceHT, // Todo
            order_amount_tf_with_sf  = cartPriceHT,
            order_discount_tf  = cart.getValueOf('total_discount'),
            order_ship_tf  = extraPriceHT,
            order_tax  = cart.getValueOf('total_tva'),
            order_payment_methods  = '',
            order_shipping_method  = (cart.isVAE() ? 'Click & Collect' : 'Livraison') + (cart.isNow() ? '':' - différé'),
            order_shipping_date  = cart.get('order_date'),
            order_shipping_time  = cart.get('order_time'),
            order_status  = 'Panier',
            order_promo_code  = cart.getVoucher().pluck('description').join(';'),
            order_currency  = CURRENCY_CODE,
            order_newcustomer  = app.getCustomer().isProspect() ? 'Prospect':'Client',
            order_piece_number  = cart.getPieces(),
            order_products = getListProduct('default'),
            order_products_annexe  = getListProduct('consumables'); // todo

            if(pagename === 'category'){
                var category = app.getCategories().findWhere({link_rewrite:options.link_rewrite});
                if(category) order_product_list_name = category.getName();
            }

            filter = getFilter();

        }
        order_products_number = order_products.length || 0;

        var tc_vars_order = {
            //
            //list_products : list_products ,
            //
            order_id : order_id ,
            //
            user_recency : user_recency ,
            // Order ID
            basket_id : id_cart ,
            // Basket ID created when a product is added to the basket
            order_amount_ati_without_sf : order_amount_ati_without_sf,
            // Order amount ATI (all tax included) without shipping fee
            order_amount_ati_with_sf : order_amount_ati_with_sf,
            // Order amount ATI (all tax included) with shipping fee
            order_discount_ati : order_discount_ati,
            // Order discount ATI (all tax included) - let empty if no discount
            order_ship_ati : order_ship_ati,
            // Order shipping fee ATI (all tax included)
            order_amount_tf_without_sf : order_amount_tf_without_sf,
            // Order amount TF (tax free) without shipping fee
            order_amount_tf_with_sf : order_amount_tf_with_sf,
            // Order amount TF (tax free) with shipping fee
            order_discount_tf : order_discount_tf,
            // extra price HT = frais de gestion
            fees: extraPriceHT,
            // Order discount TF (tax free) - let empty if no discount
            order_ship_tf : order_ship_tf,
            // Order shipping fee TF (tax free)
            order_tax : order_tax,
            // Order cagnotte usage
            order_comin_amount : order_comin_amount,
            // TODO : pourquoi dupliquer la variable d'usage de la cagnotte ?
            total_burn : total_burn ,
            // Taxes
            order_payment_methods : order_payment_methods,
            // Payment methods (VISA, CB,MASTERCARD,AMEX,â€¦) - JavaScript array if several payment methods for the same order
            order_shipping_method : order_shipping_method,
            // Shipping method ("livraison" ou "emporter")
            order_shipping_date : order_shipping_date,
            // Shipping date
            order_shipping_time : order_shipping_time,
            // Shipping time
            order_status : order_status,
            // Order status ("validated","rejected")
            order_promo_code : order_promo_code,
            // List of promotionnal codes/coupons in the order - JavaScript array if several coupons for the same order
            order_currency : order_currency,
            // Currency code (ISO code 4217)
            order_newcustomer : order_newcustomer,
            // First order or already client
            order_piece_numbre : order_piece_number,
            // piece commande
            order_products_number : order_products_number,
            //
            order_product_list_name : order_product_list_name,
            // Number of products into the order
            order_products : order_products,
            order_products_annexe : order_products_annexe,
            //-----------------------------------------------------------------
            // store
            //-----------------------------------------------------------------
            store_id : store_id,
            // Store ID
            store_name : store_name,
            // Store name
            store_postal_code : store_postal_code,
            // Store postal code
            store_city : store_city,
            // Store postal code
            store_country : store_country,
            // Store postal code

            delai : delai,
            filter : filter, // filtres ingrédients et allergen
        };
        return tc_vars_order;
    }

    function getTagCommanderTemplateVars(pagename,options){

        var pagenameToLowerCase = pagename.toLowerCase(),
            env_work = site_vars.env,
            env_channel = formatDetect(), //
            env_language = site_vars.iso_lang,
            env_template = getEnvTemplate(pagenameToLowerCase),
            page_title = document.title.toString(),
            page_cat1 = getPageCat1(pagenameToLowerCase,options),
            page_cat2 = getPageCat2(pagenameToLowerCase,options),
            page_cat3 = getPageCat3(pagenameToLowerCase,options),
            page_cat_id_1 = getPageCatId1(pagenameToLowerCase,options),
            order_step = getOrderStep(pagenameToLowerCase,options),
            page_name_tc = pagename || 'default',
            page_name = getPageName(page_name_tc,options),
            page_error = ''; // TODO gérer les 404 / erreurs

        switch(pagename){
            case 'NotFound':
                page_error = pagename;
                break;
        }

        return {
            env_work:env_work,
            env_channel:env_channel,
            env_language:env_language,
            // Website language
            env_country:COUNTRY_CODE,
            // Country
            env_template : env_template,
            page_title : page_title ,
            page_cat1 : page_cat1 ,
            page_cat2 : page_cat2 ,
            page_cat3 : page_cat3 ,
            page_cat_id_1 : page_cat_id_1 ,
            page_name_tc : page_name_tc ,
            page_name : page_name,
            page_error : page_error,
            //
            order_step : order_step,
            //
            site_version : site_vars.deploy_tag_version+'('+site_vars.asset_version+')'
        }
    }

    function getTagCommanderVars(pagename,options){
        //
        //
        //
        var // customer
            customer = app.getCustomer(),
            isLogged = customer.isLogged(),
            orders = customer.getOrders(),
            cart = app.getCart(),
            id_customer = customer.get('id_customer') || '',
            id_customer_comein = customer.getIdComein() || '',
            id_customer_neolane = customer.getIdNeolane() || '',
            id_gender = customer.get('id_gender') || '',
            birthday = customer.get('birthday') || '',
            user_email = customer.get('email') || '',
            is_newsletter = customer.isNewsletter(),
            isSms = customer.isSms(),
            user_email_optin = isLogged ? is_newsletter ? 1 : 0 : '',
            user_frequency = orders.size(), // nombre de commande déjà passée
            user_status = user_frequency > 0 ? (user_frequency > 1 ? 'Client' : 'Nouveau client') : 'Prospect', // > 1 = visiteur identifié comme ayant déjà passé commande
            user_subscription_date = customer.get('date_add') || '', //

            // customer address
            address = customer.getPrimaryAddress(),
            postcode = address ? address.getPostcode() : '',
            user_city = address ? address.get('city') || '' : '',
            // new variables
            user_optin = isLogged ? is_newsletter && isSms ? 'SMS + Mail' : is_newsletter ? 'Mail' : isSms ? 'SMS' : 'None' : 'N/A',
            user_payment  = !!customer.getCards().size() ? 'Yes':'No',
            user_category  = customer.getSegmentName(),

            preset_adress = !!address ? 'Yes':'No',
            env_meteo = 'N/A',

            tc_vars = {
                //-----------------------------------------------------------------
                // customer
                //-----------------------------------------------------------------
                user_id_customer_comin : id_customer_comein ,
                user_id_customer_neolane :id_customer_neolane ,

                client_id : getClientId(),
                user_id  : id_customer,
                // Visitor ID
                user_gender : id_gender == 1 ? 'Homme' : id_gender == 2 ? 'Femme' : '',
                // Visitor Gender
                user_birthdate : birthday ,
                // Visitor Birthdate
                user_postalcode : postcode ,
                // Visitor postal code
                user_category : user_category ,
                // Visitor category (internal CRM segmentation)
                user_frequency : user_frequency ,
                // F - Visitor frequency (number of purchases)
                user_subscription_date : user_subscription_date ,
                // Visitor subscription date
                user_last_connexion_date : '' ,
                // Visitor last connexion date
                user_email : user_email ,
                // Email of the customer
                user_email_optin : user_email_optin ,
                // Visitor optin newsletter or not
                user_city : user_city ,
                // Visitor city
                user_zipcode : postcode ,
                // Visitor zipcode
                user_country : !!id_customer ? COUNTRY_CODE.toLowerCase() : '' ,
                // Visitor country
                user_status : user_status ,
                // Visitor status : customer or prospect

                // new variables
                user_optin:user_optin,
                user_payment:user_payment,

                preset_adress:preset_adress,
                env_meteo:env_meteo,
            };

            return _.extend(
                tc_vars,
                getTagCommanderTemplateVars(pagename,options),
                getTagCommanderOrderVars(pagename,options),
                getTagCommanderProductVars(pagename,options)
            );
        }

    // tc_events_3
    function events_3(element,data) {
        try {
            if (typeof tc_events_3 == 'function') {
                tc_events_3(element, 'click', data);
            }
        } catch (e) {
        }
    }


    var TagCommander = {

        tc_delete_product: function (element, id_product, from) {
            id_product = parseInt(id_product);
            var data = {
                'click_name': '',
                'click_value': '',
                'product_id': "'" + id_product + "'",
                'product_ref': $('input[name="tc_reference_' + id_product + '"]').val(),
                'product_name': $('input[name="tc_name_' + id_product + '"]').val(),
                'product_cat': $('input[name="tc_category_' + id_product + '"]').val(),
                'product_unitprice_ati': $('input[name="tc_price_ttc_' + id_product + '"]').val(),
                'product_discount_ati': '',
                'product_unitprice_tf': $('input[name="tc_price_ht_' + id_product + '"]').val(),
                'product_discount_tf': '',
                'product_currency': '',
                'product_url_page': $('input[name="tc_link_' + id_product + '"]').val(),
                'product_url_picture': $('input[name="tc_link_picture_' + id_product + '"]').val(),
                'product_isbundle': $('input[name="tc_is_menu_' + id_product + '"]').val(),
                'product_quantity': '1',
            }, click_name, click_value;
            switch (from) {
                case 'block_checkout_products':
                    click_name = "delete_product";
                    click_value = "basket";
                    break;

                case 'block_cart_top':
                case 'block_cart_right_minus':
                    click_name = "delete_product";
                    click_value = "navigation";
                    break;

                default:
                    return false;
                    break;
            }
            data.click_name = click_name;
            data.click_value = click_value;
            events_3(element, data);

        },
        // DEPRECATED FEATURE - TODO à supprimer
        tc_add_product: function (element, id_product, quantity, from) {
            var data = {
                'click_name': '',
                'click_value': '',
                'product_id': "'" + id_product + "'",
                'product_ref': $('input[name="tc_reference_' + id_product + '"]').val(),
                'product_name': $('input[name="tc_name_' + id_product + '"]').val(),
                'product_cat': $('input[name="tc_category_' + id_product + '"]').val(),
                'product_unitprice_ati': $('input[name="tc_price_ttc_' + id_product + '"]').val(),
                'product_discount_ati': '',
                'product_unitprice_tf': $('input[name="tc_price_ht_' + id_product + '"]').val(),
                'product_discount_tf': '',
                'product_currency': 'EUR',
                'product_url_page': $('input[name="tc_link_' + id_product + '"]').val(),
                'product_url_picture': $('input[name="tc_link_picture_' + id_product + '"]').val(),
                'product_isbundle': $('input[name="tc_is_menu_' + id_product + '"]').val(),
                'product_quantity': "'" + quantity + "'",
            },
                click_name = 'add_qty', // default
                click_value;
            switch (from) {
                case 'block_product_options':
                    click_name = "add_to_cart";
                    click_value = "category";
                    break;

                case 'block_product':
                    click_name = "add_to_cart";
                    click_value = "product";
                    break;

                case 'block_cart_top_plus':
                case 'block_cart_right_plus':
                    click_value = "navigation";
                    break;

                case 'block_cart_top_minus':
                case 'block_cart_right_minus':
                    click_name = "delete_qty";
                    click_value = "navigation";
                    break;

                case 'checkoutopc': // view ?
                    click_value = "navigation";
                    break;

                case 'cart':
                    click_value = "basket";
                    break;

                case 'block_checkout_products_plus':
                    click_value = "basket";
                    break;

                case 'block_checkout_products_minus':
                    click_name = "delete_qty";
                    click_value = "basket";
                    break;
                default:
                    return false;
                    break;
            }
            data.click_name = click_name;
            data.click_value = click_value;
            events_3(element, data);
        },


        /* // DEPRECATED
        tc_product: function (element) {
            var id_product = $(element).attr('rel');

            var data = {
                'click_name': 'product',
                'page_cat1': $('input[name="tc_category_' + id_product + '"]').val(),
                'page_cat2': '', //
                'page_name': '', // important
                'product_id': "" + id_product + "",
                'product_ref': $('input[name="tc_reference_' + id_product + '"]').val(),
                'product_name': $('input[name="tc_name_' + id_product + '"]').val(),
                'product_cat': $('input[name="tc_category_' + id_product + '"]').val(),
                'product_unitprice_ati': $('input[name="tc_price_ttc_' + id_product + '"]').val(),
                'product_discount_ati': '',
                'product_unitprice_tf': $('input[name="tc_price_ht_' + id_product + '"]').val(),
                'product_discount_tf': '',
                'product_currency': 'EUR',
                'product_url_page': $('input[name="tc_link_' + id_product + '"]').val(),
                'product_url_picture': $('input[name="tc_link_picture_' + id_product + '"]').val(),
                'product_isbundle': $('input[name="tc_is_menu_' + id_product + '"]').val(),
                'product_quantity': '',
            };
            events_3(element, data);

        },
        */

        getFilter:getFilter,

        // erreurs
        tc_err:function(targetEl,title,message){
            TagCommander.tc_events_21(targetEl,{
                click_level1:"Erreur",
                click_level2:title,
                click_level3:message,
                click_value:"",
                nonInteraction:""
            })
        },
        tc_events_21:function(targetEl,options){
            try{
                window.tc_events_21(targetEl,'event',options)
            }catch(err){
            }
        },

        eventGA:function(targetEl,level1,level2,level3,options){
            TagCommander.tc_ev_gl(targetEl,'eventGA',_.defaults(options,{
                click_level1:level1,
                click_level2:level2,
                click_level3:level3,
            }));
        },

        tc_ev_gl:function(targetEl,type,options){
            // tc_events_global
            var params = {};
            switch(type){
                case 'eventGA':
                    params = _(options).defaults({
                        click_level1:"",
                        click_level2:"",
                        click_level3:"",
                        click_value:"",
                        nonInteraction:""
                    });
                    break;
                case 'promotion_click':
                    var widget = options.model;
                    _(params).extend({
                        'promotion_id':widget.id,// TODO
                        'promotion_name':widget.get('name'),
                        'promotion_creative':'',// TODO
                        'promotion_slot':'',// TODO
                        'promotion_type':widget.getClassName(),// TODO
                    });
                    break;
                case 'product_click':
                case 'product_add':
                case 'product_remove':
                    var product = options.product;
                    if(!!product) {
                        var isCartProduct = product.name === 'CartProductModel',
                            cartProduct = isCartProduct ? product : false,
                            baseProduct = isCartProduct ? product.getProduct() : product,
                            targetProduct = isCartProduct ? cartProduct : product,
                            productCategory = baseProduct ? baseProduct.getCategoryDefault() : '';

                        if(baseProduct)
                        _(params).extend({
                            'product_id': baseProduct.id,
                            'product_name': baseProduct.getName(),
                            'product_cat': productCategory ? productCategory.getName() : '',
                            'product_unitprice_ati': targetProduct.getPrice(isCartProduct ? 'price_ttc' : 'ttc', true),
                            'product_unitprice_tf': baseProduct.getPrice('ht', true), // caution : wrong values
                            'product_discount_ati': 0,
                            'product_discount_tf': 0,
                            'product_currency': CURRENCY_CODE,
                            'product_isbundle': baseProduct.isMenu() ? 'Yes' : 'No',
                            //'product_index': '',// TODO
                            //'product_list_name': '' // TODO
                        });
                    }
                break;
                default:
                params = options;
            }
            try{
                window.tc_events_global(targetEl,type,params)
            }catch(err){
            }
        },

        setup:function(appModel){
            app = appModel;
            app.getCustomer().on('login logout',resetClientId);
        },

        LoadPage:function(page,options){


            //
            // ignore le premier chargement de page
            //
            options = _.defaults(options,{});

            var url = BASE_TC_VARS_JS+'formatview='+formatDetect()+'&page=' + page;

            switch(page){
                case 'product':
                    url += '&id_product=' + options.id_product;
                    break;
                case 'category':
                    url += '&link_rewrite=' + options.link_rewrite;
                    break;
            }

            var tcStack = [app.c('_TAGCOMMANDERURLHEADER_'),app.c('_TAGCOMMANDERURLFOOTER_')];

            // function ShiftStack(){
            //     var tcUrl = tcStack.shift();
            //     if(tcUrl){
            //         LoadScriptAsync(tcUrl).done(ShiftStack);
            //     }
            // }

            try {
                var wipTCVars = getTagCommanderVars(page, options),
                    tC = window.tC;

                window.tc_vars = wipTCVars;

                if (ignoreInitialPageLoad) {
                    ignoreInitialPageLoad = !ignoreInitialPageLoad;
                    tcStack = [];
                }else if(!!tC){
                    tC.event.contentChange();
                }
                //ShiftStack();
            }catch(err){
                app.error('TagCommanderError',{message:err.message});
            }
        }
    };
    return TagCommander;
});
